import React, { useState } from "react";
import { preferences1, preferences2, preferences3, preferences4 } from "../../../assets";

const Preferences = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const items = [
    {
      id: "01",
      image: preferences1,
      title: "Müasir İnfrastruktur",
      text: "Mərkəzimiz ən son texnologiyalarla təchiz edilmiş, rahat və funksional iş sahələri təqdim edir. Hər detal işinizin səmərəliliyini artırmaq və sizə müasir biznes həlləri təklif etmək üçün nəzərə alınıb.",
    },
    {
      id: "02",
      image: preferences2,
      title: "Əlverişli Məkan",
      text: "Mərkəzimiz ən son texnologiyalarla təchiz edilmiş, rahat və funksional iş sahələri təqdim edir. Hər detal işinizin səmərəliliyini artırmaq və sizə müasir biznes həlləri təklif etmək üçün nəzərə alınıb.",
    },
    {
      id: "03",
      image: preferences3,
      title: "Geniş Xidmətlər",
      text: "Mərkəzimiz ən son texnologiyalarla təchiz edilmiş, rahat və funksional iş sahələri təqdim edir. Hər detal işinizin səmərəliliyini artırmaq və sizə müasir biznes həlləri təklif etmək üçün nəzərə alınıb.",
    },
    {
      id: "04",
      image: preferences4,
      title: "Təhlükəsizlik",
      text: "Mərkəzimiz ən son texnologiyalarla təchiz edilmiş, rahat və funksional iş sahələri təqdim edir. Hər detal işinizin səmərəliliyini artırmaq və sizə müasir biznes həlləri təklif etmək üçün nəzərə alınıb.",
    },
  ];

  const handleToggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
  <div className="bg-[black] md:rounded-t-[40px] mt-[80px]">
      <div className="max-w-containerSm md:max-w-container mx-auto py-[80px] text-white md:block hidden">
      {/* Sol taraf: Fotoğraflar */}

      <p className="text-[24px] md:text-[40px] font-bold md:font-semibold font-barlow text-center">Bizimlə İşinizdə Həmişə Bir Addım <span className='font-barlow text-[#E11E26]'>Öndəsiniz</span></p>
      <div className="flex flex-col md:flex-row justify-between items-start mt-[48px]">
      <div className="flex flex-col gap-4 md:w-[527px]">
        {items.map((item, index) => (
          <img
            key={index}
            src={item.image}
            alt={item.title}
            className={`transition-all duration-300 ease-in-out h-[74px] rounded-lg shadow-lg object-cover ${
              index === activeIndex ? "h-[216px]" : "h-[74px]"
            }`}
          />
        ))}
      </div>

      {/* Sağ taraf: Başlıklar ve açıklamalar */}
      <div className="flex flex-col gap-4 md:w-[648px]">
        {items.map((item, index) => (
          <div key={index} className={`rounded-lg shadow-md h-[74px] ${
            index === activeIndex ? "h-[130px]" : "h-[74px]"
          }`}>
            <div
              className="flex justify-between  cursor-pointer"
              onClick={() => handleToggle(index)}
            >
              <div className="flex">
              <h2 className="text-[#E11E26] text-[24px] font-semibold">{item.id}</h2>
              <h2 className="text-[24px] font-semibold ml-10">{item.title}</h2>
              </div>
              <div className="flex justify-start items-start">
              <span className="text-[48px] font-bold text-[#E11E26] relative bottom-5 h-5 ">{activeIndex === index ? "-" : "+"}</span>
              </div>
            </div>
            {activeIndex === index && (
              <p className="mt-2 text-[#999999] ml-[70px] text-[14px]">{item.text}</p>
            )}
          </div>
        ))}
      </div>
      </div>
    </div>
    <div className="max-w-containerSm md:max-w-container mx-auto py-[80px] text-white md:hidden block">
      {/* Sol taraf: Fotoğraflar */}

      <p className="text-[24px] md:text-[40px] font-bold md:font-semibold font-barlow text-center">Bizimlə İşinizdə Həmişə Bir Addım <span className='font-barlow text-[#E11E26]'>Öndəsiniz</span></p>
      <div className="flex flex-col md:flex-row justify-between items-start mt-[48px]">

      {/* Sağ taraf: Başlıklar ve açıklamalar */}
      <div className="flex flex-col gap-4 md:w-[648px]">
        {items.map((item, index) => (
          <div key={index} className={`rounded-lg shadow-md h-[74px] ${
            index === activeIndex ? "h-[360px]" : "h-[74px]"
          }`}>
            <div
              className="flex justify-between  cursor-pointer"
              onClick={() => handleToggle(index)}
            >
              <div className="flex">
              <h2 className="text-[#E11E26] text-[24px] font-semibold">{item.id}</h2>
              <h2 className="text-[24px] font-semibold ml-10">{item.title}</h2>
              </div>
              <div className="flex justify-start items-start">
              <span className="text-[48px] font-bold text-[#E11E26] relative bottom-5 h-5 ">{activeIndex === index ? "-" : "+"}</span>
              </div>
            </div>
            {activeIndex === index && (
              <>
              <p className="mt-2 text-[#999999] text-[14px]">{item.text}</p>
              <img
            key={index}
            src={item.image}
            alt={item.title}
            className={`transition-all duration-300 ease-in-out h-[74px] rounded-lg object-cover shadow-lg mt-4 ${
              index === activeIndex ? "h-[216px]" : "h-[74px]"
            }`}
          /></>
            )}

          </div>
        ))}
      </div>
      </div>
    </div>
  </div>
  );
};

export default Preferences;